// extracted by mini-css-extract-plugin
export default {"external":"az0gs7","wrapper":"bz0gs7","image":"cz0gs7","block":"dz0gs7","link":"ez0gs7","assetsLinksBlock":"fz0gs7","status":"gz0gs7","title":"hz0gs7"};